import getAddOnPrice from './getAddOnPrice';

export default function getTotalPrice(subscription, isAnnual) {
  const {
    addOns,
    annualPrice,
    listPrice,
    productCode,
  } = subscription;

  let price = isAnnual ? annualPrice : listPrice;
  if (addOns.length) {
    addOns.forEach((addOn) => {
      const addOnPrice = getAddOnPrice(addOn, isAnnual, productCode);
      price += addOnPrice;
    });
  }
  return price;
}
